import { ReminderSettingTypeEnum } from "../reminders/reminder.enum";
import { ReminderSettingModel } from "./reminder-setting-model";

export class ReminderSettingsModelExtended extends ReminderSettingModel {
  type!: ReminderSettingTypeEnum;

  constructor(reminderSetting: ReminderSettingModel, type: ReminderSettingTypeEnum) {
    super(reminderSetting);
    this.type = type;
  }
}
